(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $mjRaB = parcelRequire("mjRaB");

var $gzKpA = parcelRequire("gzKpA");

var $jwBDG = parcelRequire("jwBDG");
(0, $jwBDG.onReset)(()=>{
    const picker = document.getElementById("calendar-picker");
    picker.value = "";
});
const $96c680cc956e9f1c$var$onPickerValueChange = (picker)=>{
    const value = picker.value;
    const date = new Date(value);
    (0, $mjRaB.triggerDateChange)(picker, date);
};
function $96c680cc956e9f1c$var$observeValue(element) {
    let elementPrototype = Object.getPrototypeOf(element);
    let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, "value");
    const { get: get, set: set } = descriptor;
    if (!get || !set) throw new Error("Cannot listen to value change; no getter or setter on value descriptor");
    Object.defineProperty(element, "value", {
        get: function() {
            return get.call(this);
        },
        set: function(val) {
            set.call(this, val);
            setTimeout(()=>{
                $96c680cc956e9f1c$var$onPickerValueChange(element);
            }, 0);
        }
    });
}
(0, $gzKpA.onInit)(()=>{
    const picker = document.getElementById("calendar-picker");
    $96c680cc956e9f1c$var$observeValue(picker);
    picker.addEventListener("change", ()=>{
        $96c680cc956e9f1c$var$onPickerValueChange(picker);
    });
});

})();
//# sourceMappingURL=index.d0b216d1.js.map
